import React from 'react'
import { l } from '@manychat/manyui'

export const BusinessAccountDeleted = () => {
  return (
    <span>
      {l.translate(
        'Your WhatsApp Business account has been deleted and is no longer connected to Manychat',
      )}
    </span>
  )
}
